<div class="mat-typography move-dialog">
  <div class="dialog-header">
    {{ getDialogTitle() }}
  </div>

  <div class="horizontal-separator"></div>

  <div class="dialog-container">
    @if (isLoading) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    } @else {
      <div class="tree-container">
        @if (dataSource.data && dataSource.data.length > 0) {
          <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
            <!-- Leaf node template -->
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding
              matTreeNodePaddingIndent="20"
              (click)="onTreeNodeSelect(node)"
              [ngClass]="{
                'selected': isSelected(node),
                'disabled': isDisabled(node),
                'current-location': node.id === currentPath
              }">
              <button mat-icon-button [disabled]="true" [style.visibility]="'hidden'"></button>
              @if (node.level === 0 && node.is_project) {
                <span class="icon icon-project"></span>
              } @else {
                <span class="icon icon-folder"></span>
              }
              <span [class.greyed-out]="isDisabled(node)">
                {{ node.name }}
                @if (node.id === currentPath && data.itemType !== 'folder') {
                  <span class="current-label">(current folder)</span>
                }
                @if (data.itemType === 'folder' && data.itemId === node.id) {
                  <span class="current-label">(current folder)</span>
                }
              </span>
            </mat-tree-node>

            <!-- Expandable node template -->
            <mat-tree-node *matTreeNodeDef="let node; when: hasChild"
              matTreeNodePadding
              matTreeNodePaddingIndent="20"
              (click)="onTreeNodeSelect(node)"
              [ngClass]="{
                'selected': isSelected(node),
                'disabled': isDisabled(node),
                'current-location': node.id === currentPath || (data.itemType === 'folder' && data.itemId === node.id)
              }">
              <button mat-icon-button matTreeNodeToggle
                [attr.aria-label]="'Toggle ' + node.name"
                (click)="onNodeToggle(node, $event)">
                <mat-icon class="mat-icon">
                  {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                </mat-icon>
              </button>
              @if (node.level === 0 && node.is_project) {
                <span class="icon icon-project"></span>
              } @else {
                <span class="icon icon-folder"></span>
              }
              <span [class.greyed-out]="isDisabled(node)">
                {{ node.name }}
                @if (node.id === currentPath && data.itemType !== 'folder') {
                  <span class="current-label">(current folder)</span>
                }
                @if (data.itemType === 'folder' && data.itemId === node.id) {
                  <span class="current-label">(current folder)</span>
                }
              </span>
            </mat-tree-node>
          </mat-tree>
        } @else {
          <p class="empty-state">No folders available</p>
        }
      </div>
    }
  </div>

  <div class="button-row">
    <button mat-flat-button class="frmg-secondary-button"
            (click)="cancel()">Cancel
    </button>
    <button mat-raised-button class="frmg-primary-button"
            [disabled]="!canMove() || isLoading"
            (click)="move()">
         {{ getMoveButtonText() }}
    </button>
  </div>
</div>

